import { render } from "./Components.vue?vue&type=template&id=98abb0e2&ts=true"
import script from "./Components.vue?vue&type=script&lang=ts"
export * from "./Components.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__